export default __webpack_public_path__ + "static/media/m1.f3a5659d.png";